import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend';
import './Component_PrettyPrint_Binary.scss';
import { BadImplementationException, exists } from '@nu-art/ts-common';
import { PPDescription, PPIndicatorStatus } from '../../Component_PrettyPrint_Description/Component_PrettyPrint_Description.js';
const getStrings = (operator) => {
    switch (operator) {
        case 'addition':
        case 'positive':
            return { title: 'Sum of:', operation: 'And:' };
        case 'subtraction':
        case 'negative':
            return { title: 'Difference of:', operation: 'And:' };
        case 'multiplication':
            return { title: 'Product of:', operation: 'Multiplied by:' };
        case 'division':
            return { title: 'Quotient of:', operation: 'Divided by:' };
        case 'or':
            return { title: 'Either:', operation: 'Or:' };
        case 'and':
            return { title: 'Both:', operation: 'And:' };
        default:
            return { title: `Missing implementation for case ${operator}`, operation: '' };
    }
};
const getStatus = (operator, valueNode, interactive) => {
    if (!interactive)
        return;
    switch (operator) {
        case 'or':
        case 'and':
            //Expected value type is boolean
            if (typeof valueNode?.value !== 'boolean')
                return PPIndicatorStatus.dataNeeded;
            return valueNode?.value ? PPIndicatorStatus.pass : PPIndicatorStatus.fail;
        case 'addition':
        case 'subtraction':
        case 'division':
        case 'multiplication':
        case 'positive':
        case 'negative':
            //Expected value type is number
            return typeof valueNode?.value === 'number'
                ? PPIndicatorStatus.pass
                : PPIndicatorStatus.dataNeeded;
    }
};
export const Component_PrettyPrint_Binary = (props) => {
    if (exists(props.valueNode) && props.valueNode.type !== 'binary')
        throw new BadImplementationException(`ValueTree_Node type mismatch: expected "binary", got "${props.valueNode.type}"`);
    const { title, operation } = getStrings(props.expression.operator);
    const status = getStatus(props.expression.operator, props.valueNode, props.interactive);
    const className = _className('binary-description', status);
    return _jsxs(PPDescription, { className: className, "data-operator": props.expression.operator, children: [_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: title })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.leftHand, props.valueNode?.left)] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: operation })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.rightHand, props.valueNode?.right)] })] });
};
//# sourceMappingURL=Component_PrettyPrint_Binary.js.map